export default __webpack_public_path__ + "8e7be10381ebb84b8e8f2099836c2542.svg";